import { render, staticRenderFns } from "./JcdcDataTableGroupIcon.vue?vue&type=template&id=6ed62f5a"
import script from "./JcdcDataTableGroupIcon.vue?vue&type=script&lang=ts"
export * from "./JcdcDataTableGroupIcon.vue?vue&type=script&lang=ts"
import style0 from "./JcdcDataTableGroupIcon.vue?vue&type=style&index=0&id=6ed62f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports